var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blurb"},[_c('h1',[_vm._v("Alex Stone")]),_c('h2',[_vm._v("software developer")]),_c('p',[_vm._v("solving complex problems with creativity and curiosity")])])
}]

export { render, staticRenderFns }